(function () {
  var STORAGE_KEY = 'tmb_cookie_consent';
  var COOKIE_NAME = 'tmb_cookie_consent';
  var COOKIE_MAX_AGE_DAYS = 180;

  function readStoredConsent() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (parsed && typeof parsed === 'object' && typeof parsed.analytics === 'boolean') {
        return parsed;
      }
    } catch (e) {}
    return null;
  }

  function writeStoredConsent(consent) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(consent));
    } catch (e) {}
    try {
      var maxAge = COOKIE_MAX_AGE_DAYS * 24 * 60 * 60;
      document.cookie = COOKIE_NAME + '=' + encodeURIComponent(JSON.stringify(consent)) +
        '; path=/; max-age=' + maxAge + '; SameSite=Lax';
    } catch (e) {}
  }

  function applyConsent(consent) {
    window.themenbrandConsent = window.themenbrandConsent || {};
    window.themenbrandConsent.necessary = true;
    window.themenbrandConsent.analytics = !!consent.analytics;
    window.themenbrandConsent.marketing = !!consent.marketing;
    document.dispatchEvent(new CustomEvent('themenbrandConsentUpdated', { detail: consent }));
  }

  function saveConsent(consent) {
    consent.necessary = true;
    consent.timestamp = new Date().toISOString();
    writeStoredConsent(consent);
    applyConsent(consent);
  }

  document.addEventListener('DOMContentLoaded', function () {
    var banner = document.getElementById('CookieConsent');
    var modal = document.getElementById('CookiePreferences');
    if (!banner || !modal) return;

    var analyticsToggle = document.getElementById('CookieConsentAnalytics');
    var marketingToggle = document.getElementById('CookieConsentMarketing');

    function showBanner() {
      banner.classList.add('is-visible');
    }
    function hideBanner() {
      banner.classList.remove('is-visible');
    }
    function openModal() {
      var existing = readStoredConsent();
      if (analyticsToggle) analyticsToggle.checked = existing ? !!existing.analytics : false;
      if (marketingToggle) marketingToggle.checked = existing ? !!existing.marketing : false;
      modal.classList.add('is-visible');
    }
    function closeModal() {
      modal.classList.remove('is-visible');
    }

    var existingConsent = readStoredConsent();
    if (existingConsent) {
      applyConsent(existingConsent);
    } else {
      showBanner();
    }

    banner.querySelector('[data-cookie-consent-accept]').addEventListener('click', function () {
      saveConsent({ analytics: true, marketing: true });
      hideBanner();
    });

    banner.querySelector('[data-cookie-consent-necessary]').addEventListener('click', function () {
      saveConsent({ analytics: false, marketing: false });
      hideBanner();
    });

    banner.querySelector('[data-cookie-consent-manage]').addEventListener('click', function () {
      openModal();
    });

    modal.querySelector('[data-cookie-consent-close]').addEventListener('click', closeModal);

    modal.querySelector('[data-cookie-consent-save]').addEventListener('click', function () {
      saveConsent({
        analytics: !!(analyticsToggle && analyticsToggle.checked),
        marketing: !!(marketingToggle && marketingToggle.checked)
      });
      hideBanner();
      closeModal();
    });

    modal.addEventListener('click', function (event) {
      if (event.target === modal) closeModal();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && modal.classList.contains('is-visible')) closeModal();
    });

    // Public API so a footer/menu link (or a future analytics loader) can
    // reopen preferences or check the current consent state.
    window.themenbrandConsent = window.themenbrandConsent || {};
    window.themenbrandConsent.necessary = true;
    window.themenbrandConsent.analytics = existingConsent ? !!existingConsent.analytics : false;
    window.themenbrandConsent.marketing = existingConsent ? !!existingConsent.marketing : false;
    window.themenbrandConsent.open = openModal;
  });
})();
